export default "__VITE_ASSET__DknCBYe$__"